// extracted by mini-css-extract-plugin
module.exports = {"loader":"buttonWithLoader_loader__9nip6","load3":"buttonWithLoader_load3__A3U3a"};